import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { FrontEndRoutes } from '../config/front-end-routes';
import { trackContactEvent } from '../utils/trackingEvents';

const Header: React.FC = () => {
  const { config, whatsappUrl, logoUrl } = useSite();
  const location = useLocation();
  const currentPath = location.pathname;

  const navClass = (path: string) =>
    `text-profile-1 fw-medium ${currentPath === path ? 'active border-bottom border-profile-3 border-2' : ''}`;

  return (
    <>
      <div className="bg-profile-1 text-white py-2 d-none d-md-block">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-4">
              {config?.phone && <span><i className="fas fa-phone-alt me-2"></i>{config.phone}</span>}
              {config?.whatsapp && <span><i className="fab fa-whatsapp me-2"></i>{config.whatsapp}</span>}
              {config?.email && <span><i className="fas fa-envelope me-2"></i>{config.email}</span>}
            </div>
            <div className="d-flex align-items-center gap-3">
              {config?.facebook_url && <a href={config.facebook_url} className="text-white" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>}
              {config?.instagram_url && <a href={config.instagram_url} className="text-white" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>}
              {config?.linkedin_url && <a href={config.linkedin_url} className="text-white" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>}
            </div>
          </div>
        </Container>
      </div>

      <Navbar bg="white" variant="light" expand="lg" className="shadow-sm sticky-top">
        <Container>
          <Navbar.Brand as={Link} to={FrontEndRoutes.HOME} className="d-flex align-items-center">
            <img src={logoUrl('/img/LOGOSPERANDIO.png')} alt={config?.site_title || 'Sperandio Oral Center'} height="40" className="me-2" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-nav" />
          <Navbar.Collapse id="main-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to={FrontEndRoutes.HOME} className={navClass(FrontEndRoutes.HOME)}>Início</Nav.Link>
              {config?.show_services !== false && <Nav.Link as={Link} to={FrontEndRoutes.SERVICES} className={navClass(FrontEndRoutes.SERVICES)}>Serviços</Nav.Link>}
              {config?.show_team !== false && <Nav.Link as={Link} to={FrontEndRoutes.TEAM} className={navClass(FrontEndRoutes.TEAM)}>Equipe</Nav.Link>}
              {config?.show_about !== false && <Nav.Link as={Link} to={FrontEndRoutes.ABOUT} className={navClass(FrontEndRoutes.ABOUT)}>Sobre</Nav.Link>}
              {config?.show_contact !== false && <Nav.Link as={Link} to={FrontEndRoutes.CONTACT} className={navClass(FrontEndRoutes.CONTACT)}>Contato</Nav.Link>}
            </Nav>
            <Button
              variant="primary"
              className="bg-profile-1 border-profile-1 rounded-pill px-4"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackContactEvent}
            >
              <i className="fab fa-whatsapp me-2"></i>Agendar via WhatsApp
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
